var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLiveBlogArticle)?_c('AdFormBanner',{key:_vm.bannerKey,attrs:{"ad-type":"header","settings":{
    mid: _vm.headerAd.mid,
    adBlockFallback: _vm.headerAd.adb,
    group: _vm.headerAd.group,
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }